window.showBankFields = function (show) {
    if (show === true) {
        $('#require-bank').removeClass('hidden');
        $("#require-bank select, #require-bank input").each(function () {
            $(this).prop('required', true);
            $(this).val('');
        });
    } else {
        $('#require-bank').addClass('hidden');
        $("#require-bank select, #require-bank input").each(function () {
            $(this).prop('required', false);
            $(this).val('');
        });
    }
}

window.showAddressFields = function (show) {
    if (show === true) {
        $('#require-address').removeClass('hidden');
        $("#require-address #postcode, #require-address #address_1, #require-address #city_town, #require-address #county, #require-address #country").each(function () {
            $(this).prop('required', true);
            $(this).val('');
        });
    } else {
        $('#require-address').addClass('hidden');
        $("#require-address #postcode, #require-address #address_1, #require-address #city_town, #require-address #county, #require-address #country").each(function () {
            $(this).prop('required', false);
            $(this).val('');
        });
    }
}
